import "./Services.css";
import ServicesHero from "./ServicesHero/ServicesHero";
import ServicesAccordions from "./ServicesAccordions/ServicesAccordions"
import ServicesCTA from "./ServicesCTA/ServicesCTA"
import SEO from "../../components/SEO/SEO";

function Services() {
  return (
    <div className="services-container">
              <>
              <SEO
                title="Leistungen | Fit2Clean"
                description="Wir bieten eine Vielzahl von Reinigungs-Dienstleistungen an."
                canonical="https://www.fit-to-clean.de/services"
              />    

      <div className="services-hero fade-in-up">
        <ServicesHero
          eyebrow="Leistungen"
          title="Gebäudereinigung für Büros, Praxen und Gewerbeflächen"
          text="Fit2Clean übernimmt die regelmäßige Reinigung von Büros, Praxen, Treppenhäusern und sanitären Bereichen im gesamten MVV-Gebiet rund um München. Ergänzend koordinieren wir Spezial- und Sonderreinigungen über ausgewählte Partnerbetriebe."
        />
      </div>

      <div className="service-accordions fade-in-up">
        <ServicesAccordions
        title="Unsere Leistungen im Detail"
        text="Regelmäßige Reinigung durch unsere eigenen Teams sowie ergänzende Sonderleistungen über Partnerbetriebe – alles aus einer Hand."
        items={[
            {
                category: "Regelmäßige Reinigung",
                title: "Büroreinigung",
                text: "Wir reinigen Arbeitsplätze, Empfangsbereiche, Besprechungsräume und Laufwege nach klar strukturierten Reinigungsplänen. Staubfreie Oberflächen, leere Papierkörbe und hygienisch gepflegte Arbeitsbereiche sorgen für ein angenehmes Arbeitsumfeld – Tag für Tag."
            },
            {
                category: "Medizin & Gesundheit",
                title: "Praxisreinigung",
                text: "Wir berücksichtigen die besonderen Hygieneanforderungen im medizinischen Umfeld. Behandlungsräume, Wartezonen und Sanitärbereiche werden gründlich gereinigt, Oberflächen hygienisch aufbereitet und Kontaktpunkte regelmäßig desinfiziert."
            },
            {
                category: "Gemeinschaftsflächen",
                title: "Treppenhausreinigung",
                text: "Saubere Treppenhäuser und Eingangsbereiche schaffen einen positiven ersten Eindruck. Wir reinigen Stufen, Geländer und Türflächen regelmäßig und sorgen so für Sicherheit, Sauberkeit und gepflegte Zugänge im gesamten Objekt."
            },
            {
                category: "Sanitärbereiche",
                title: "Reinigung sanitärer Bereiche",
                text: "Sanitärräume benötigen eine zuverlässige und gründliche Pflege. Wir reinigen Toiletten, Wasch- und Duschräume mit wirksamen, aber schonenden Mitteln und sorgen für eine dauerhaft angenehme Hygiene."
            },
            {
                category: "Hygiene",
                title: "Desinfektionen",
                text: "In sensiblen Zonen und bei saisonalem Infektionsdruck setzen wir gezielte Desinfektionsleistungen ein. So reduzieren wir Keime an relevanten Kontaktpunkten und steigern Sicherheit und Wohlbefinden der Nutzerinnen und Nutzer."
            },
            {
                category: "Partnerleistungen",
                title: "Teppichboden-Grundreinigung*",
                text: "Wir organisieren tiefenwirksame Teppichreinigungen über spezialisierte Partner. Dadurch werden festsitzende Verschmutzungen und Laufspuren beseitigt und die Lebensdauer der Bodenbeläge erhöht."
            },
            {
                category: "Partnerleistungen",
                title: "Außenbereichsreinigung*",
                text: "Auch außerhalb des Gebäudes sorgen wir für Ordnung und Sauberkeit – von Gehwegen über Eingangsflächen bis hin zu Müllstandorten. Ideal für ganzheitlich gepflegte Immobilien."
            },
            {
                category: "Partnerleistungen",
                title: "Sonderreinigung & Graffiti-Entfernung*",
                text: "Bei außergewöhnlichen Verschmutzungen oder Graffiti reagieren wir schnell und effektiv. Die passende Spezialreinigung wird je nach Materialoberfläche mit rücksichtsvollen Methoden durchgeführt."
            }
        ]}
      />
      </div>

      <div className="cta">
       <ServicesCTA
          eyebrow="Nächster Schritt"
          title="Bereit für ein sauberes Büro?"
          text="Gern beraten wir Sie persönlich und erstellen ein Angebot, das wirklich passt."
          ctaLabel="Kontakt aufnehmen"
          ctaHref="/contact"
          note="Unverbindlich & schnell – wir melden uns innerhalb von 24 Stunden."
        />
      </div>
      </>
    </div>
  );
}

export default Services;
